export default __webpack_public_path__ + "static/media/solanaLogo.b6b66c17.svg";